import { render } from "./Group.vue?vue&type=template&id=da3ab7aa&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"

import "./Group.vue?vue&type=style&index=0&id=da3ab7aa&scoped=true&lang=css"

import exportComponent from "/home/trit/trit/dev/caspwebapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da3ab7aa"]])

export default __exports__